import {NgModule} from '@angular/core';
import {UF_ENTITY_PROVIDER} from './uf.entity-provider';
import {CoreModule} from '../../core/core.module';
import {DynamicModule} from '../../core/shared/interface/dynamic-module.interface';
import {ModuleRegistryService} from '../../core/shared/interface/module-registration.service';
import {UiModule} from '../../core/ui/ui.module';

// Components
import {UfFlowComponent} from './component/protected-components/uf-flow/uf-flow.component';
import {
    UfFlowStepActivityComponent
} from './component/protected-components/uf-flow-step-activity/uf-flow-step-activity.component';
import {
    UfFlowActivityFormComponent
} from './component/protected-components/uf-flow-activity-form/uf-flow-activity-form.component';
import {
    UfFlowActivityValidationComponent
} from './component/protected-components/uf-flow-activity-validation/uf-flow-activity-validation.component';
import {
    UfFlowStepActionComponent
} from './component/protected-components/uf-flow-step-action/uf-flow-step-action.component';
import {
    UfFormTypeObjectComponent
} from './component/object-components/uf-form-type-object-component/uf-form-type-object.component';
import {
    UfFormObjectComponent
} from './component/object-components/uf-form-object-component/uf-form-object.component';
import {
    UfFormRendererComponent
} from './component/protected-components/uf-form-renderer/uf-form-renderer.component';
import {
    UfFlowTypeObjectComponent
} from './component/object-components/uf-flow-type-object-component/uf-flow-type-object.component';
import {
    UfFlowTypeStepObjectComponent
} from './component/object-components/uf-flow-type-step-object-component/uf-flow-type-step-object.component';
import {
    UfFlowTypeStepActivityObjectComponent
} from './component/object-components/uf-flow-type-step-activity-object-component/uf-flow-type-step-activity-object.component';

// Pages
import {UfConfigPage} from './page/config/uf-config/uf-config.page';
import {UfFlowPage} from './page/object/uf-flow/uf-flow.page';
import {UfFormTypePage} from './page/object/uf-form-type/uf-form-type.page';
import {UfFormPage} from './page/object/uf-form/uf-form.page';
import {UfPlaygroundPage} from './page/playground/uf-playground/uf-playground.page';
import {UF_WF_ACTIVITY_PROVIDER} from './uf-wf-activity.provider';

@NgModule({
    declarations: [
        UfFlowComponent,
        UfFlowStepActivityComponent,
        UfFlowActivityFormComponent,
        UfFlowActivityValidationComponent,
        UfFlowStepActionComponent,
        UfFormTypeObjectComponent,
        UfFormObjectComponent,
        UfFormRendererComponent,
        UfFlowTypeObjectComponent,
        UfFlowTypeStepObjectComponent,
        UfFlowTypeStepActivityObjectComponent,
        UfConfigPage,
        UfFlowPage,
        UfFormTypePage,
        UfFormPage,
        UfPlaygroundPage,
    ],
    exports: [
        UfFlowComponent,
        UfFlowStepActivityComponent,
        UfFlowStepActionComponent,
        UfFormRendererComponent,
    ],
    imports: [
        CoreModule,
        UiModule,
    ],
    providers: [UF_ENTITY_PROVIDER, ...UF_WF_ACTIVITY_PROVIDER]
})
export class UfModule implements DynamicModule {

    alias = 'uf';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return null;
    }

    getStatisticsComponent() {
        return null;
    }

}
